import { ParameterQuery } from "utils/commonFunctions";

interface CosmeticGradingEndpoint {
    baseUrl: string;
    apiKey: string;
}

const DEV_COSMETIC_GRADING_ENDPOINT: CosmeticGradingEndpoint = {
    baseUrl: "https://dev-cosmeticgrading.mobilesolutions.ai/",
    apiKey: "7cfb7519-dc14-436c-8881-20be8da0d68a",
};

const COSMETIC_GRADING_ENDPOINT_BY_STAGE: Record<string, CosmeticGradingEndpoint> = {
    dev: DEV_COSMETIC_GRADING_ENDPOINT,
    demo: DEV_COSMETIC_GRADING_ENDPOINT,
    staging: {
        baseUrl: "https://staging-cosmeticgrading.mobilesolutions.ai/",
        apiKey: "7cfb7519-dc14-436c-8881-20be8da0d68a",
    },
    prod: {
        baseUrl: "https://cosmeticgrading.mobilesolutions.ai/",
        apiKey: "b652-6bff-fb60-51ba",
    },
};

const CURRENT_STAGE = process.env.STAGE ?? "dev";
const COSMETIC_GRADING_ENDPOINT = COSMETIC_GRADING_ENDPOINT_BY_STAGE[CURRENT_STAGE] ?? DEV_COSMETIC_GRADING_ENDPOINT;

export function buildCosmeticGradingUrl(tenantUuid: string, assetIdentifier?: string): string {
    const queryString = new ParameterQuery()
        .add("key", COSMETIC_GRADING_ENDPOINT.apiKey)
        .add("tenant_uuid", tenantUuid)
        .add("asset_identifier", assetIdentifier)
        .createQueryString();
    return COSMETIC_GRADING_ENDPOINT.baseUrl + queryString;
}
